<template>
  <div>
    <modal-vue class="col-lg-12">
      <div slot="header">
        <h3>{{text}}</h3>
      </div>
      <div slot="body"></div>
      <div slot="footer" class="text-center">
        <lms-button class="col-lg-6" :disabled="false" @click="confirm()" :loading="loading">Sim</lms-button>
        <lms-button
          class="col-lg-6"
          :danger="true"
          :disabled="false"
          @click="cancel()"
          :loading="loading"
        >Não</lms-button>
      </div>
    </modal-vue>
  </div>
</template>


<style lang="scss" scoped>
</style>


<script>
import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  props: {
    text: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    confirm() {
      this.$emit("confirm");
    },
    cancel() {
      this.$emit("cancel");
    }
  },
  created() {}
};
</script>
